import { clearCache, layoutWithLines, prepareWithSegments } from '@chenglou/pretext';

/** Prepared segments are reused on resize; no DOM measurements in the hot path. */
const cache = new Map<string, ReturnType<typeof prepareWithSegments>>();

export function textLayout(text: string, font: string, width: number, lineHeight: number,
    whiteSpace: 'normal' | 'pre-wrap' = 'normal') {
    const key = `${font}\u0000${whiteSpace}\u0000${text}`;
    let prepared = cache.get(key);
    if (!prepared) {
        prepared = prepareWithSegments(text, font, { whiteSpace });
        // Bound memory when used by the resident chat on every route.
        if (cache.size >= 128) cache.delete(cache.keys().next().value);
        cache.set(key, prepared);
    }
    return layoutWithLines(prepared, Math.max(1, width), lineHeight);
}

export function clearTextLayoutCache() {
    cache.clear();
    clearCache();
}
